import axios from 'axios'
import VueCookies from 'vue-cookies'
import CryptoJS from 'crypto-js'

const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_FAIL = 'LOGIN_FAIL'
const LOGOUT = 'LOGOUT'

export const state = {
  pending: false,
  token: VueCookies.get('token'),
  isLoggedIn: !!VueCookies.get('token'),
  permissions: '',
  currentuser: ''
}

export const mutations = {
  [LOGIN] (state) {
    state.pending = true
  },
  [LOGIN_SUCCESS] (state) {
    state.isLoggedIn = true
    state.pending = false
  },
  [LOGIN_FAIL] (state) {
    state.pending = false
  },
  [LOGOUT] (state) {
    state.isLoggedIn = false
  }
}

export const actions = {
  login ({ commit }, creds) {
    commit(LOGIN) // show spinner
    return axios({
      method: 'post',
      url: process.env.API_ENDPOINT + '/user/login',
      data: creds
    })
  },
  logout ({commit}) {
    VueCookies.remove('token')
    commit(LOGOUT)
  },
  STORE_SESSIONS ({ commit }, data) {
    VueCookies.set('token', data.token, 2419200)

    console.log(data)

    let curuser = {
      id: data.id,
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email
    }
    localStorage.setItem('session_user', CryptoJS.AES.encrypt(JSON.stringify(curuser), data.token))

    localStorage.setItem('session_company', JSON.stringify(data.company))
    localStorage.setItem('session_permissions', CryptoJS.AES.encrypt(data.permissions.join(), data.token))
    localStorage.setItem('session_roles', JSON.stringify(data.roles))
    localStorage.setItem('session_user_login_count', JSON.stringify(data.login_count))
  }
}

export const getters = {
  token: state => {
    return state.token
  },
  isLoggedIn: state => {
    return state.isLoggedIn
  },
  permissions: (state) => {
    if (localStorage.getItem('session_permissions')) {
      let encrtyptedpermissions = localStorage.getItem('session_permissions')
      var bytes = CryptoJS.AES.decrypt(encrtyptedpermissions.toString(), state.token)
      var permissions = bytes.toString(CryptoJS.enc.Utf8)
      return permissions.split(',')
    } else {
      return []
    }
  },
  currentuser: (state) => {
    if (localStorage.getItem('session_user')) {
      let encrtypteduser = localStorage.getItem('session_user')
      var bytes = CryptoJS.AES.decrypt(encrtypteduser.toString(), state.token)
      var currentuser = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      return currentuser
    } else {
      return {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js